module.exports = __webpack_public_path__ + "static/img/ruzhu_img_url2.4ac36726.png";